module.exports = __webpack_public_path__ + "static/media/iphone6-3up-grid.8e014a7f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/smartphone/iphone6/iphone6-3up-grid.pdf
// module id = 40
// module chunks = 0